import React, { useContext, useMemo,useEffect} from "react";
import {View,StyleSheet, Dimensions} from "react-native";
import styled from "styled-components";
import { THEME_COLORS } from '../../../common/themes';
import { useTable, useBlockLayout, useRowSelect, useSortBy, useResizeColumns } from 'react-table';
import TBody from './components/TBody';
import THeader from './components/THeader';
import { useSticky } from 'react-table-sticky';
import { SparesContext, SparesInterface } from "../../../screen/SparePartsScreen/context/SparesContext";

const WIDTH = Dimensions.get('window').width;

const Styles = styled.div`

  .table {
    overflow-y:scroll;
    height:inherit;
    width:inherit;

    .tr {
      width:inherit;
      z-index:1;
      .td:last-child  {
        // background-color: black !important;
      }
      .resizer {
        display: inline-block;
        width: 2px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;
        background:#e5e5e5;
        ${'' /* prevents from scrolling while dragging on touch devices */}
        touch-action:none;

        &.isResizing {
          background: red;
        }
      }

      // .resizer:hover{
      //   background:black;
      // }
    }

    .th{
      min-height:65px;
      padding:10px;
      background-color:#fafafa;
      // box-shadow: -1px 0px 5px #ccc;
    }

    .td {
      padding: 5px;
      padding-left: 10px;
      overflow: hidden;
      border:none;
      // box-shadow: -1px 0px 5px #ccc;
      :last-child {  
      }
    }
 
    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }
 
      .header {
        top: 0;
        position:sticky;
        width:inherit;
      }
 
      .footer {
        bottom: 0;
      }
 
      .body {
        position: relative;
        z-index: 0;
        height:inherit;
        width:inherit;
      }

      .hideScrollbar::-webkit-scrollbar{
        display: none; 
       }
 
      [data-sticky-td] {
        position: sticky;
      }
 
      [data-sticky-last-left-td] {
        border-right:1px solid #efefef;
        box-shadow: 4px 0px 5px #ccc;
      }
 
      [data-sticky-first-right-td] {
        border-left:1px solid #efefef;
        box-shadow: -4px 0px 5px #ccc;
      }
    }
  }
`;

interface IDataTableProps{
  tableId:string;
  data:any;
  columns:any;
  onClickSort?: (selector, direction) => void;
  rowBgColor?:string;
  getRowId?: (row, relativeIndex, parent?: any) => string;
  getRowProps?: (row?: any) => any;
}

const DataTable=(props:IDataTableProps)=>{
  
    const { state } = useContext<SparesInterface>(SparesContext)

    const {data, columns, onClickSort,tableId,rowBgColor, getRowId, getRowProps} = props;
    const newWidth = WIDTH/columns.length;
    const memoizedValue = useMemo(() => columns.map((item,index) => {

      let tableData = localStorage.getItem(tableId) ? JSON.parse(localStorage.getItem(tableId)) : null;
      let locallyStoredWidthForColumn = tableData && tableData[index] ? tableData[index] : null;

      return {
          Header:item.name,
          Cell:({ row }) =>  item.cell(row.original),
          id:index.toString(),
          sticky:item.sticky ?? null,
          width: locallyStoredWidthForColumn ? locallyStoredWidthForColumn :  item.width ? item.width : newWidth < 200 ? 200 : newWidth,
          disableSortBy: !!item.sortable ? false : true,
          accessor:item.selector ?? "",
          selector:item.selector
      }
    }), [columns]);

    let tableOptions = { columns: memoizedValue, data, manualSortBy: true, autoResetSortBy: false,}

    // @ts-ignore
    if (getRowId) tableOptions = { ...tableOptions, getRowId };
  
    const tableInstance = useTable(tableOptions, useBlockLayout, useSortBy, useRowSelect, useResizeColumns, useSticky);

    const { getTableProps, headerGroups, state: { columnResizing }, rows } = tableInstance;

      const adjustWidth=(obj)=>{
        let newObj = {};
        Object.keys(obj)?.forEach(key => {
          if(obj[key] < 50){
            newObj[key] = 50;
          }else{
            newObj[key] = obj[key];
          }
        });

        return newObj;
      }

    useEffect(() => {
      if (columnResizing.isResizingColumn === null) {
        let widthObj=columnResizing.columnWidths;
        widthObj = adjustWidth(widthObj);
        const locallyStoredWidthForTableId = localStorage.getItem(tableId);
        if(!!locallyStoredWidthForTableId){
          widthObj = {...JSON.parse(locallyStoredWidthForTableId),...widthObj};
        }
        if(!!tableId && columnResizing.columnWidths){
          localStorage.setItem(tableId,JSON.stringify(widthObj));
        }
      }
    }, [columnResizing]);

    return (
      <View style={styles.container}>
        <Styles style={{height:'100%',position:"relative",width:"100%"}}>
          <div {...getTableProps()} className="table sticky" style={{width:"inherit",height:'inherit'}}>
            <THeader headerGroups={headerGroups} onClickSort={onClickSort} />
            <TBody
            getRowProps={getRowProps ?? ((row) => {

              return ([{
                style: {
                  backgroundColor: !!rowBgColor ? rowBgColor : (state.fromQCToIRData && row?.original?.id === state.fromQCToIRData?.requestItemId) ? '#c5dbf0' : (row.index % 2 !== 0 ? THEME_COLORS.grey2 : THEME_COLORS.white),
                }
              }])
            })}
              bodyProps={tableInstance} />
          </div>
        </Styles>
      </View>
    )
}

const styles = StyleSheet.create({
  container:{
    flexShrink:1,
  }
})

export default DataTable;
